<template>
  <TheMenuLayout>
    <TheBreadCrumbs :items="breadcrumbItems" />
    <div v-if="!currentConversation.admin_user.id">
      <span>Veuillez choisir un professeur :</span>
      <v-select
        label="Professeur"
        v-model="selectedAdminUser"
        :items="adminUsers"
        item-text="name"
        item-value="id"
        required
      />
    </div>
    <div>
    </div>
    <v-card flat color="grey lighten-5">
      <v-card-title>
        Conversation avec {{ currentConversation.admin_user.name || (selectedAdminUser && selectedAdminUser.name) || '...' }}
      </v-card-title>
      <v-card-text class="d-flex flex-column">
        <div
          v-for="message in sortedConversationMessages"
          :key="message.id"
          class="message white--text pa-4 mb-4 elevation-3 rounded-lg"
          :class="{
            'teal': !message.from_admin,
            'grey': message.from_admin,
            'align-self-end': !message.from_admin,
            'align-self-start': message.from_admin
          }"
        >
          <div v-html="message.content" />
          <div
            v-for="(image, index) in message.message_files"
            :key="index"
          >
            <a :href="image.url">
              <img v-if="image.thumbnail_url" :src="image.thumbnail_url" alt="">
              <div v-else>
                <v-icon small>mdi-paperclip</v-icon>{{ image.filename }}
              </div>
            </a>
          </div>
          <strong>
            <small>
              <template v-if="message.from_admin">
                {{ currentConversation.admin_user.name }}
              </template>
              <template v-else>
                Vous
              </template>
              - {{ message.created_at | moment('from') }}
            </small>
          </strong>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-text v-if="files.length">
        Fichiers joints :
        <div
          v-for="(file, index) in files"
          :key="index"
        >
          {{ file.name }}
          <v-icon color="red" @click="files.splice(index, 1)">
            mdi-delete
          </v-icon>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-textarea
          v-model="message"
          append-icon="mdi-send"
          prepend-icon="mdi-paperclip"
          filled
          clear-icon="mdi-close-circle"
          clearable
          label="Message"
          type="text"
          counter
          rows="2"
          auto-grow
          required
          :disabled="messageIsBeingSent"
          :loading="messageIsBeingSent"
          @click:append="sendMessage"
          @click:prepend="clickFileInput"
          @click:clear="clearMessage"
        />
        <input accept="image/*" type="file" ref="fileInput" @change="onFileChange" class="d-none">
      </v-card-actions>
    </v-card>
  </TheMenuLayout>
</template>

<script>
import {
  mapState, mapActions, mapMutations, mapGetters,
} from 'vuex';
import TheMenuLayout from '@/components/TheMenuLayout.vue';
import TheBreadCrumbs from '@/components/TheBreadcrumbs.vue';
import BaseButton from '@/components/BaseButton.vue';

export default {
  name: 'Conversation',
  components: {
    TheMenuLayout,
    TheBreadCrumbs,
    BaseButton,
  },
  data() {
    return {
      message: '',
      messageIsBeingSent: false,
      selectedAdminUser: undefined,
      files: [],
    };
  },
  computed: {
    ...mapState(['currentConversation', 'adminUsers']),
    ...mapGetters(['sortedConversationMessages']),
    breadcrumbItems() {
      return [
        {
          text: 'Questions',
          disabled: false,
          href: '/conversations',
        },
        {
          text: this.currentConversation.admin_user.name,
          disabled: true,
          href: `/conversations/${this.currentConversation.id}`,
        },
      ];
    },
  },
  created() {
    if (this.$route.params.id) {
      this.fetchCurrentConversation(this.$route.params.id);
    } else {
      this.fetchAdminUsers();
    }
  },
  methods: {
    ...mapActions(['fetchCurrentConversation', 'postMessage', 'fetchAdminUsers']),
    ...mapMutations(['setAlert']),
    clickFileInput() {
      this.$refs.fileInput.click();
    },
    onFileChange(event) {
      const file = event.target.files[0];
      this.files.push(file);
    },
    sendMessage() {
      if (!this.message) {
        this.setAlert({
          text: 'Veuillez écrire un message.',
          color: 'error',
          show: true,
        });
        return;
      }
      if (!this.selectedAdminUser && !this.currentConversation.id) {
        this.setAlert({
          text: 'Veuillez choisir un professeur',
          color: 'error',
          show: true,
        });
        return;
      }
      this.messageIsBeingSent = true;
      this.postMessage({
        message: this.message,
        adminUserId: this.selectedAdminUser,
        files: this.files,
      }).then((response) => {
        this.message = '';
        this.files = [];
        if (!this.$route.params.id) {
          this.$router.replace(`/conversations/${response.data.id}`);
        }
      }).finally(() => {
        this.messageIsBeingSent = false;
      });
    },
    clearMessage() {
      this.message = '';
    },
  },
};
</script>

<style lang="scss" scoped>
.message {
  max-width: 80%;

  a {
    text-decoration: none;
    color: white;
  }
}
</style>
